import createAxios from './api'

const PATH = 'users/self/signatureProfiles'

export default {
  async createMySignatureProfile(dto) {
    const axios = await createAxios()
    await axios.post(`${PATH}`, dto)
  },

  async getMySignatureProfile(name) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${name}`)

    return resp.data
  },

  async listMySignatureProfiles(q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}`, {
      params: {
        q,
        ...pageRequest
      }
    })

    return resp.data
  },

  async getSignatureProfiles() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/by-user`)

    return resp.data
  },

  async updateMySignatureProfile(id, dtoUpdate) {
    const axios = await createAxios()
    await axios.put(`${PATH}/${id}`, dtoUpdate)
  },

  async deleteMySignatureProfile(name) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${name}`)
  }
}
